import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Phone, Menu, X } from 'lucide-react';
import './Navbar.css';

function Navbar() {
    const [menuOpen, setMenuOpen] = useState(false);

    const handleNavClick = (e, targetId) => {
        e.preventDefault();

        if (targetId === 'home') {
            const homeElement = document.getElementById('home');
            if (homeElement) {
                homeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
            } else {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        } else {
            const element = document.getElementById(targetId);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }

        setMenuOpen(false);
    };

    return (
        <nav className="navbar">
            <div className="navbar-container">
                <div className="navbar-logo" onClick={(e) => handleNavClick(e, 'home')}>
                    <img
                        src="/logo-horizontal.webp"
                        alt="CleanSweep Logo"
                        style={{ cursor: 'pointer' }}
                    />
                </div>

                <ul className="navbar-links-desktop">
                    <li>
                        <a href="#home" onClick={(e) => handleNavClick(e, 'home')}>Home</a>
                    </li>
                    <li>
                        <a href="#about-us" onClick={(e) => handleNavClick(e, 'about-us')}>About Us</a>
                    </li>
                    <li>
                        <a href="#activities" onClick={(e) => handleNavClick(e, 'activities')}>Activities</a>
                    </li>
                    <li>
                        <a href="#contact-us" onClick={(e) => handleNavClick(e, 'contact-us')}>Contact Us</a>
                    </li>
                    <li>
                        <a href="tel:+971508364814" className="nav-call-button">
                            <Phone size={18} /> +971 50 8364814
                        </a>
                    </li>
                </ul>

                <button className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
                    {menuOpen ? <X size={28} /> : <Menu size={28} />}
                </button>
            </div>

            <AnimatePresence>
                {menuOpen && (
                    <>
                        <motion.div
                            className="mobile-backdrop"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            onClick={() => setMenuOpen(false)}
                        />
                        <motion.div
                            className="mobile-menu"
                            initial={{ x: '100%' }}
                            animate={{ x: 0 }}
                            exit={{ x: '100%' }}
                        >
                            <ul className="mobile-nav-links">
                                <li>
                                    <a href="#home" onClick={(e) => handleNavClick(e, 'home')}>Home</a>
                                </li>
                                <li>
                                    <a href="#about-us" onClick={(e) => handleNavClick(e, 'about-us')}>About Us</a>
                                </li>
                                <li>
                                    <a href="#activities" onClick={(e) => handleNavClick(e, 'activities')}>Activities</a>
                                </li>
                                <li>
                                    <a href="#contact-us" onClick={(e) => handleNavClick(e, 'contact-us')}>Contact Us</a>
                                </li>
                                <li className="mobile-call-item">
                                    <a href="tel:+971508364814">
                                        <Phone size={20} /> Call Now
                                    </a>
                                </li>
                            </ul>
                        </motion.div>
                    </>
                )}
            </AnimatePresence>
        </nav>
    );
}

export default Navbar;
